import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import tr from 'date-fns/locale/tr';

import { workOrderFormActions } from "../../../../store/slices/forms/workOrderForm";
import CustomInput from "../../../../components/atoms/Input";
import { plusIcon } from '../../../../assets/factory-icons';
import editIcon from '../../../../assets/icon-edit.svg';
import trashIcon from '../../../../assets/icon-delete.svg';
import { workOrderRowCells } from "../constants";
import { UtilityFunctions } from "../../../../utils"
import CustomDropdown from '../../../../components/molecules/CustomFilter';
import { ProductService } from "../../../../service";
import { useEffect } from "react";

registerLocale('tr', tr)

export default function ProductInformationRow({ rowData, readOnly, viewMode = false }) {
    let { productInformation } = useSelector(state => state.workOrderForm);

    // get the products list
    const [products, setProducts] = useState();

    useEffect(() => {
        const fetchProducts = async () => {

            try {
                const data = await ProductService.getProductsService();
                const products = data.map(item => item.code)
                setProducts(products)
            } catch (error) {
                console.log(error)
            } 
        };

        fetchProducts();
    }, [])

    productInformation = readOnly ? rowData : productInformation;

    const { data, productCode } = productInformation;
    const CustomDatePickerInput = React.forwardRef(({ value, onClick, cell }, ref) => (
        <CustomInput
            onClick={onClick}
            ref={ref}
            className={cell.className}
            placeholder={cell.placeholder}
            id={cell.id}
            name={cell.name}
            value={data[cell.value] || productInformation[cell.value]}
            workorder
            readOnly
        />
    ));

    return (
        <Form className={`${readOnly ? 'read-only' : 'product-information-row'}`}>
            <div className={`form-row `}>
                <div className='work-order-inputs'>
                    { 
                        workOrderRowCells.map((item, index) => {
                            return (
                                <div className='row-cell' key={index}>
                                    {
                                        item.map(cell => {

                                            if (cell.datePicker) {
                                                return (
                                                    <DatePicker
                                                        // selected={date} // todo: fix this
                                                        key={cell.id}
                                                        locale={'tr'}
                                                        customInput={
                                                            <CustomDatePickerInput cell={cell} />
                                                        }
                                                    />
                                                )
                                            }

                                            // let _value = cell.name === 'productCode' ? productInformation[cell.value] : data[cell.value];
                                            let _value = data[cell.value];
                                            if (cell.name === 'productCode') {
                                                return (
                                                    <CustomDropdown
                                                        key={cell.id}
                                                        data={products}
                                                        className={'product-code'}
                                                        value={productCode}
                                                        name={cell.name}
                                                        defaultValue={"Ürün Kodu"}
                                                    />
                                                )
                                            }
                                            return (
                                                <CustomInput
                                                    key={cell.id}
                                                    className={cell.className}
                                                    placeholder={cell.placeholder}
                                                    id={cell.id}
                                                    name={cell.name}
                                                    value={_value}
                                                    workorder
                                                />
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </Form>
    );
}